@if (src(); as resolvedSrc) {
  <img [ngSrc]="resolvedSrc" width="20" height="20" [alt]="alt()" class="block rounded-sm" />
}
